export * from './pages/login-page';
export * from './pages/email-sent-page';
export * from './pages/forgot-password-page';
export * from './pages/password-changed-page';
export * from './pages/register-page';
export * from './pages/reset-password-page';
export * from './must-login-modal';
export { type SessionType } from './state';

import type { IFrontendServiceContainer } from '@phi/frontend/service-container';
import { authentication_state_provider } from './state';
import { auth_api_factory } from './api';
import { authentication_service_factory } from './use-cases';

export type IAuthentication = ReturnType<typeof authentication_provider>;

export const authentication_provider = (app: IFrontendServiceContainer) => {
    const auth_state = authentication_state_provider(app);
    const auth_api = auth_api_factory(app.api);

    return {
        ...auth_state,
        ...auth_api,
        ...authentication_service_factory(auth_api, auth_state, app),
    };
};
